import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { UserEditForm } from '../components/domain/UserEditForm'
import { useAddUserMutation } from '../ducks/users/usersApi'
import { UserEditData } from '../ducks/users/usersInterface'

export const UserAddPage = () => {
  const navigate = useNavigate()
  const [addUser] = useAddUserMutation()

  // ユーザー登録時処理
  const handleSubmit = useCallback(
    async (formData: UserEditData) => {
      try {
        await addUser(formData)

        // 反映のため少し待機（Auth0の反映遅延対策）
        await new Promise((resolve) => setTimeout(resolve, 1000))

        navigate('/users')
      } catch (error) {
console.error(error)
      }
    },
    [addUser, navigate]
  )

  return <UserEditForm onSubmitForm={handleSubmit} />
}
